export var OPEN_IN_MOBILE_COOKIE = 'openInMobile?';
export var LEAVE_COMMENT_POPOVER_COOKIE = 'leaveCommentPopover';
export var OPEN_IN_APP_IOS_BADGE_COOKIE = 'openInAppBadge';
